import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { HiOutlineArrowUp } from 'react-icons/hi';

const StyledToTop = styled.button`
    type: button;
    background-color: transparent;
    margin: 0;
    padding: 0;
    border-radius: 17px;
    color: var(--john-text-mild); 
    :hover {
        color: var(--john-text-pretty);
    }
`;

const StyledBox = styled.div`
    display: flex;
    flex-direction: column;
    margin: 3px;
`;

const GoTopButton = () => {

    const [ showGoTop, setShowGoTop ] = useState( false )

    const handleVisibleButton = () => {
        setShowGoTop( window.pageYOffset > 50 )
    }

    const handleScrollUp = () => {
        window.scrollTo( { left: 0, top: 0, behavior: 'smooth' } )
    }

    useEffect( () => {
        window.addEventListener( 'scroll', handleVisibleButton )
    }, [] )

    return (
        ( 
            showGoTop && 
            <StyledBox onClick={ handleScrollUp } >
                <StyledToTop>
                    <HiOutlineArrowUp/>
                </StyledToTop>
            </StyledBox>
        )
    )
}

export default GoTopButton;
